var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1612 75.4213C72.583 68.5846 81 55.3697 81 40.1889C81 17.9932 63.0068 0 40.811 0C18.6153 0 0.62207 17.9932 0.62207 40.1889C0.62207 54.7552 8.37141 67.5115 19.9723 74.56V66.0046C19.9723 64.9001 20.8677 64.0046 21.9723 64.0046H39.3225V61.0067C39.0029 61.0206 38.6796 61.0277 38.3526 61.0277C25.6975 61.0277 22.9492 52.3665 22.9492 46.42C22.9492 39.922 26.8874 34.5966 31.1597 28.8194C35.3367 23.171 39.8331 17.0908 41.2805 9.06048C44.8449 7.2507 58.0843 24.7784 58.0843 37.6295C58.0843 49.0763 52.4698 58.6951 42.2994 60.6606V64.0046H58.1612C59.2658 64.0046 60.1612 64.9001 60.1612 66.0046V75.4213Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo-square.7de8341f62e2b52429798e4b85195744.svg";
export { ForwardRef as ReactComponent };